/**
 * Custom Star Cursor — pink, shiny, with sparkle trail
 * Add this file to your theme's /assets folder as: custom-cursor.js
 * Loaded via theme.liquid with: {{ 'custom-cursor.js' | asset_url | script_tag }}
 */
(function () {
  // Skip on touch devices / devices without a fine pointer (phones, tablets)
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  // Respect users who prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Guard against running before <body> exists (e.g. if this script isn't
  // marked defer/async and loads while <head> is still parsing). Without
  // this, the native cursor gets hidden below but the star never gets
  // created, making the cursor appear to vanish entirely.
  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  function init() {
  document.documentElement.classList.add('has-custom-cursor');

  var cursor = document.createElement('div');
  cursor.className = 'custom-star-cursor';
  cursor.setAttribute('aria-hidden', 'true');

  var glow = document.createElement('div');
  glow.className = 'custom-star-cursor__glow';
  cursor.appendChild(glow);

  var shape = document.createElement('div');
  shape.className = 'custom-star-cursor__shape';
  glow.appendChild(shape);

  document.body.appendChild(cursor);

  var mouseX = window.innerWidth / 2;
  var mouseY = window.innerHeight / 2;
  var cursorX = mouseX;
  var cursorY = mouseY;
  var ease = 0.22;
  var lastTrailTime = 0;
  var trailInterval = 45; // ms between sparkle spawns
  var visible = false;

  function showCursor() {
    if (!visible) {
      visible = true;
      cursor.style.opacity = '1';
    }
  }

  function hideCursor() {
    visible = false;
    cursor.style.opacity = '0';
  }

  function spawnTrail(x, y) {
    var star = document.createElement('div');
    star.className = 'custom-cursor-trail';
    var size = 6 + Math.random() * 8;
    star.style.width = size + 'px';
    star.style.height = size + 'px';
    star.style.left = x + 'px';
    star.style.top = y + 'px';
    document.body.appendChild(star);
    setTimeout(function () {
      star.remove();
    }, 650);
  }

  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    showCursor();

    var now = performance.now();
    if (now - lastTrailTime > trailInterval) {
      lastTrailTime = now;
      spawnTrail(mouseX, mouseY);
    }
  });

  document.addEventListener('mouseleave', hideCursor);
  document.addEventListener('mouseenter', showCursor);

  // Grow the cursor slightly over interactive elements
  var activeSelector = 'a, button, input, textarea, select, summary, [role="button"], .card-wrapper';
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(activeSelector)) {
      cursor.classList.add('is-active');
    }
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(activeSelector)) {
      cursor.classList.remove('is-active');
    }
  });

  function animate() {
    cursorX += (mouseX - cursorX) * ease;
    cursorY += (mouseY - cursorY) * ease;
    cursor.style.transform = 'translate(' + cursorX + 'px, ' + cursorY + 'px)';
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);
  } // end init
})();